import { render } from "./CasePage.vue?vue&type=template&id=3db5e639"
import script from "./CasePage.vue?vue&type=script&lang=js"
export * from "./CasePage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WorkSpace\\webapp\\vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__